export function replaceKinstaImageUrl(url?: string): string {
  if (!url) {
    return '';
  }
  return url.replace(
    'https://immigrantinvest.com/',
    'https://iminblog.kinsta.cloud/'
  );
}
